import Client from './client';

export default class OnboardingOrganizations extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(channelId, options = {}) {
    return this.makeRequest(`${this.host}/internal/channel/${channelId}/onboarding/organizations`, options);
  }

}
